"use client";

import { usePathname } from "next/navigation";
import type React from "react";
import { useEffect, useState } from "react";
import { PageSkeleton } from "./PageSkeleton";

interface PageWrapperProps {
  children: React.ReactNode;
  pageType?: "home" | "documents" | "document" | "help" | "subscription";
}

export const PageWrapper: React.FC<PageWrapperProps> = ({ children, pageType }) => {
  const pathname = usePathname();
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [currentPath, setCurrentPath] = useState(pathname);

  // Detect page type from pathname if not provided
  const getPageType = (path: string): "home" | "documents" | "document" | "help" | "subscription" => {
    if (path === "/") return "home";
    if (path.startsWith("/documents/") && path !== "/documents") return "document";
    if (path === "/documents") return "documents";
    if (path === "/help") return "help";
    if (path === "/subscription") return "subscription";
    return "home"; // Default fallback
  };

  useEffect(() => {
    if (pathname !== currentPath) {
      setIsPageLoading(true);
      setIsPageLoading(false);
      setCurrentPath(pathname);
    }
  }, [pathname, currentPath]);

  // Show skeleton while page is loading
  if (isPageLoading) {
    return <PageSkeleton type={pageType || getPageType(pathname)} />;
  }

  return <>{children}</>;
};
